module.exports = __webpack_public_path__ + "static/media/Fitness-Square.1454d2f1.jpg";